export default function sdkMiddleware(sdk) {
  return ({ dispatch, getState }) => next => action => {
    if (!(action.meta && action.meta.apiRequest)) {
      return next(action);
    }

    // eslint-disable-next-line no-param-reassign
    delete action.meta.apiRequest;

    const { callback } = action.payload;

    return callback(sdk, dispatch, getState)
      .then(response => response)
      .catch(response => Promise.reject(response));
  };
}
